import React, { useEffect, Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom'
import { useSelector } from "react-redux";
import { getRedirectTo, handoffToSupport } from '../common/supportHandoff';
import PageLoader from '../components/PageLoader';
import PublicRoutes from './PublicRoutes';
import LoginController from '../controllers/LoginController';
import Verify2faController from '../controllers/Verify2faController';
import MagicLoginController from '../controllers/MagicLoginController';

// Heavy, login-only bundles — split out so the public landing/login entry stays small and loads fast.
const PrivateRoutes = lazy(() => import('./PrivateRoutes'));
const VerificationRoutes = lazy(() => import('./VerificationRoutes'));
const SetupWebhookModal = lazy(() => import('../view/Instructions/SetupWebhookModal'));


export default function MainRoutes() {
    const user = useSelector((state) => state.user);
    const token = user.token;
    const isEmailVerified = user.isEmailVerified;
    const is2faVerified = user.is2faVerified;
    const is2faEnabled = user.is2faEnabled;

    // Already logged in and arrived from the support portal → hand off immediately.
    useEffect(() => {
        if (getRedirectTo() === 'support' && token) {
            handoffToSupport(token);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);



    return (
        <>
            <PageLoader loading={user.isLoading} />
            <Routes>
                <Route path="/impersonate/:token?" element={<MagicLoginController />} />
            </Routes>
            <Suspense fallback={<PageLoader loading={true} />}>
                {
                    token ?
                        <>
                            {
                                !isEmailVerified ? <VerificationRoutes /> :

                                    is2faEnabled ?
                                        is2faVerified ?
                                            <>
                                                <SetupWebhookModal />
                                                <PrivateRoutes />
                                            </>
                                            :
                                            (<Routes>
                                                <Route path="/login" element={<LoginController />} />
                                                <Route path="/verify-2fa" element={<Verify2faController />} />
                                                <Route path="*" element={<LoginController />} />
                                            </Routes>
                                            ) :
                                        <>
                                            <SetupWebhookModal />
                                            <PrivateRoutes />
                                        </>
                            }
                        </>
                        :
                        <PublicRoutes />
                }
            </Suspense>
        </>


    )
}